import request from '@/utils/request';
import { baseRouterUrl } from '@/api/config';
export function sendMessage(data) {
  return request({
    url: "".concat(baseRouterUrl, "/aichat/ask"),
    method: 'post',
    data: data
  });
}
export default {
  sendMessage: sendMessage
};